import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import { login } from "../../Store/Auth/actions";
import http from "../../Services/http-common";
import {
  LoginFormDocPlace,
  useStyles,
  Wrapper,
  WrapperFormDocPlace,
  WrapperLogin,
  ResendEmail,
} from "./style";
import { toast, ToastContainer } from "react-toastify";
import logoFD from "../../Assets/Docplace_Logo.svg";
import InputDocPlace from "../../Components/Form/input";
import { useDispatch, useSelector } from "react-redux";
import { expressions } from "../../Components/Resources/index";
import LoadingComponent from "../../Components/Resources/loading";
import Visibility from "@mui/icons-material/VisibilityOutlined";
import VisibilityOff from "@mui/icons-material/VisibilityOffOutlined";
import "./style.css";
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Link,
  IconButton,
  Paper,
} from "@mui/material";

const Login = () => {
  const { classes } = useStyles();
  const notify = (msj, event) => toast[event](msj);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [userName, setUserName] = useState({ value: "", error: false });
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState({ value: "", error: false });
  const [showLogin, setShowLogin] = useState(false);
  const [resend, setResend] = useState(false);
  const [sending, setSending] = useState(false);

  const { errorLogin, responseLogin, loadingLogin } = useSelector((state) => ({
    errorLogin: state.Auth.errorLogin,
    responseLogin: state.Auth.responseLogin,
    loadingLogin: state.Auth.loadingLogin,
  }));

  /**change the title of the page */
  useEffect(() => {
    document.title = "Login";
  }, []);

  const setLogin = (e) => {
    e.preventDefault();
    if (!userName.error && !password.error) {
      //We allow any email because are external to docplace
      let obj = {
        email: userName.value,
        password: password.value,
      };
      dispatch(login(obj, navigate));
    } else {
      notify("Please enter all the required information", "error");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "email") {
      setUserName({ value: value, error: false });
    }
    if (name === "password") {
      setPassword({ value: value, error: false });
    }
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const navigateForgot = (e) => {
    e.preventDefault();
    if (userName.value) {
      navigate("/forgot-password", { state: { emailParam: userName.value } });
    } else {
      notify("Please enter your email", "error");
    }
  };

  const resendEmail = () => {
    let url =
      process.env.REACT_APP_HOST_API +
      "/billing/Api/V1/Public/SendResetPasswordLinkDocPlace";
    let body = {
      appId: "DocPlace",
      data: {
        email: userName.value,
      },
    };
    setShowLogin(true);
    http
      .post(url, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((respData) => {
        if (respData.data.success == true) {
          notify("The email has been sent", "success");
        } else {
          notify(respData.data.errors[0].description, "error");
        }
        setShowLogin(false);
      })
      .catch((response) => {
        console.log("Error: " + response);
        setShowLogin(false);
        notify("Error sending the email", "error");
      })
      .finally(() => {
        setShowLogin(false);
      });
  };

  useEffect(() => {
    if (responseLogin) {
      responseLogin.customerId = ""; //for esignature we don't have a customer id
      localStorage.setItem("esignature", JSON.stringify(responseLogin));
      navigate("/docForms");
    }
  }, [responseLogin]);

  useEffect(() => {
    if (errorLogin) {
      notify(errorLogin?.response?.data?.error?.messages[0]?.message, "error");
    }
  }, [errorLogin]);

  return (
    /* <React.Fragment>
            <MetaTags>
                <title>Login</title>
            </MetaTags>

            <div className="login-container">
                <ToastContainer autoClose={3000} />
                <LoadingComponent show={loadingLogin} text={"Login to DocPlace..."} />
                <Paper elevation={3} className="login-box">
                    <Container maxWidth="xs" sx={{ textAlign: "center", mt: 1 }}>
                        <img width={"140px"} height={"140px"} alt="docplace" src={logoFD} />
                        <Typography variant="h5" sx={{ mt: 3 }} gutterBottom>
                            eSignature sign in
                        </Typography>
                        <LoginFormDocPlace onSubmit={setLogin}>
                            <WrapperFormDocPlace>
                                <InputDocPlace
                                    id={"email"}
                                    field={email}
                                    setField={setEmail}
                                    required={true}
                                    type="email"
                                    label="Email"
                                    expresionRegular={expressions.email}
                                />
                                <InputDocPlace
                                    id={"password"}
                                    field={password}
                                    setField={setPassword}
                                    required={true}
                                    type="password"
                                    label="Password"
                                    shrink={true}
                                />
                                {
                                    <section>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            style={{ textTransform: "none" }}
                                            size={"large"}
                                            fullWidth
                                            sx={{ mt: 2 }}
                                        >
                                            Log in
                                        </Button>
                                    </section>
                                }
                                {/* <Typography variant="body2" sx={{ mt: 3, mb: 3 }}>
                                    Or Continue with:
                                </Typography> 
                                {/* <Button
                                    variant="outlined"
                                    onClick={signInWithGoogle}
                                    fullWidth
                                    startIcon={
                                        <IconButton>
                                            <img
                                                src={GoogleIcon}
                                                alt="Google Icon"
                                                style={{ width: 24, height: 24 }}
                                            />
                                        </IconButton>
                                    }
                                    sx={{
                                        mt: 1,
                                        borderColor: "#000",
                                        borderStyle: "solid",
                                        borderWidth: 1,
                                    }}
                                >
                                    <Typography className="buttonText">
                                        Sign In With Google
                                    </Typography>
                                </Button>

                                <Button
                                    variant="outlined"
                                    onClick={() => handleLogin()}
                                    sx={{
                                        mt: 1,
                                        borderColor: "#000",
                                        borderStyle: "solid",
                                        borderWidth: 1,
                                    }}
                                    className="buttonText"
                                    fullWidth
                                    startIcon={
                                        <IconButton>
                                            <img
                                                src={MicrosoftIcon}
                                                alt="Microsoft Icon"
                                                style={{
                                                    width: 24,
                                                    height: 24,
                                                }}
                                            />
                                        </IconButton>
                                    }
                                >
                                    <Typography className="buttonText">
                                        Sign In With Microsoft
                                    </Typography>
                                </Button> 

                            </WrapperFormDocPlace>
                        </LoginFormDocPlace>
                    </Container>
                </Paper>
            </div>
        </React.Fragment> */
    <React.Fragment>
      <MetaTags>
        <title>DocPlace Sign Login</title>
      </MetaTags>
      <div className="login-container">
        <ToastContainer autoClose={3000} />
        <LoadingComponent
          show={loadingLogin || showLogin}
          text={"Login to DocPlace..."}
        />
        <Paper elevation={3} className="login-box">
          <Container maxWidth="xs" sx={{ textAlign: "center", mt: 1 }}>
            {
              <>
                <img alt="docplace" src={logoFD} />
                <Typography variant="h5" sx={{ mt: 3 }} gutterBottom>
                  Sign In
                </Typography>

                <Box component="form" onSubmit={setLogin} sx={{ mt: 2 }}>
                  {
                    <>
                      <Typography
                        variant="body2"
                        className="labelText"
                        align="left"
                      >
                        Email
                      </Typography>
                      <TextField
                        fullWidth
                        label=""
                        name="email"
                        type="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        margin="normal"
                        required
                      />
                      <Typography
                        variant="body2"
                        className="labelText"
                        align="left"
                        sx={{ mt: 2 }}
                      >
                        Password
                      </Typography>
                      <TextField
                        placeholder="Enter your password"
                        fullWidth
                        label=""
                        name="password"
                        type={showPassword ? "text" : "password"}
                        value={formData.password}
                        onChange={handleChange}
                        margin="normal"
                        required
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              style={{ color: "#a0a0a0" }}
                              onClick={handleTogglePassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </>
                  }

                  {
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ textTransform: "none" }}
                      size={"large"}
                      fullWidth
                      sx={{ mt: 2 }}
                    >
                      Log in
                    </Button>
                  }
                </Box>

                {
                  <>
                    <Link
                      onClick={navigateForgot}
                      variant="body2"
                      sx={{ display: "block", mt: 2, mb: 4, cursor: "pointer" }}
                    >
                      Forgot password?
                    </Link>
                    <ResendEmail onClick={resendEmail}>
                      {resend == true && sending == false && (
                        <div> Resend activation email </div>
                      )}
                      {resend == true && sending == true && (
                        <div
                          style={{
                            color: "lightgray",
                            pointerEvents: "none",
                          }}
                        >
                          {" "}
                          Resend activation email{" "}
                        </div>
                      )}
                    </ResendEmail>
                  </>
                }
              </>
            }{" "}
          </Container>
        </Paper>
      </div>
    </React.Fragment>
  ); 
};

export default Login;
